import { Injectable } from '@angular/core';
import * as mixpanel from 'mixpanel-browser';
import { getUserData } from '../../util/manageUserData';
declare let gtag: Function;
@Injectable({
  providedIn: 'root',
})
export class MixpanelServiceService {
  /**
   * Initialize mixpanel.
   *
   * @param {string} userToken
   * @memberof MixpanelServiceService
   */
  init(): void {
    // mixpanel.init('300ce4b745c13a8fda146a16da20ebe4');
    // mixpanel.identify(userToken);
  }

  /**
   * Push new action to mixpanel.
   *
   * @param {string} id Name of the action to track.
   * @param {*} [action={}] Actions object with custom properties.
   * @memberof MixpanelServiceService
   */
  track(id, action): void {
    mixpanel.init('7eab5a7e664037d33aa4649078f103a7');

    //Collecting Data
    let token = '';
    const userDataStorage = getUserData();
    if (id != 'Log in') {
      token = userDataStorage['token'];
      let userDetails =
        userDataStorage['store_detail_dictionary']['user_details'];
      let storeDetailsArray =
        userDataStorage['store_detail_dictionary']['store_details_array'];

      let logo_image_url = '';
      let client_name = '';
      let first_location_name = '';
      let count_of_stores = storeDetailsArray.length;

      if (count_of_stores > 0) {
        let store_details = storeDetailsArray[0];
        logo_image_url = store_details['logo_image_url'];
        client_name = store_details['shop_location'];
        first_location_name = store_details['text'];
      }

      let name = userDetails['name'];
      let email = userDetails['email_address'];

      //Mixpanel

      let user_dictionary = { $email: email, $name: name };
      user_dictionary['$avatar'] = logo_image_url;
      user_dictionary['client_name'] = client_name;
      user_dictionary['first_location_name'] = first_location_name;
      user_dictionary['count_of_stores'] = count_of_stores;

      mixpanel.identify(token); //Token
      mixpanel.people.set(user_dictionary); //User details
      mixpanel.add_group('client', client_name); //Grouping users under a client
    }

    mixpanel.track(id, action);
    //Google Analytics

    gtag('config', 'G-GJ9JEBDXJ9', {
      user_id: token,
    });
    gtag('event', id, {});
  }
}
